import {
  constructList,
  getText,
  sortAndSliceList,
  appendGOATandCountryCodeToTitle,
  stripSpecialCharacterFromString,
} from 'shared/utils/pageMetadataUtils';
import { startCase } from 'shared/utils/startCase';

export const getDesignerValueMetadata = ({
  pageTitle,
  pageDescription,
  constructorResponse,
  locale,
  query,
}) => {
  const { groups = [], results = [] } = constructorResponse?.response || {};
  const designerValue: string = query?.designerValue;
  const designerValueWithStartCase: string = startCase(designerValue);
  const topLevelCategory: string =
    groups?.[0]?.group_id === 'sneakers'
      ? 'shoes'
      : stripSpecialCharacterFromString(groups?.[0]?.group_id);
  const topLevelCategoryWithStartCase: string = startCase(topLevelCategory);

  const topTwoPTs = constructList({
    list: sortAndSliceList(results, 2),
    key: 'value',
  });

  // Pulling out static strings for translation purposes
  const authenticityAssured = 'Authenticity assured';
  const buy = 'Buy';
  const designedBy = 'designed by';
  const fromThe = 'From the';
  const newReleasesAndIconicStyles = 'New Releases & Iconic Styles';
  const onGOAT = 'on GOAT';
  const shop = 'Shop';
  const toThe = 'to the';

  const _topTwoPTs = topTwoPTs?.constructedListWithStartCase?.map((string) =>
    string?.trim() === '&' ? ` ${toThe} ` : string,
  );
  const fromThePT1toThePT2 = getText(fromThe, _topTwoPTs);

  const title = `${buy} ${designerValueWithStartCase} ${topLevelCategoryWithStartCase}. ${newReleasesAndIconicStyles}`;
  const description = `${shop} ${topLevelCategory} ${designedBy} ${designerValueWithStartCase} ${onGOAT}. ${fromThePT1toThePT2}. ${authenticityAssured}.`;

  return {
    pageTitle: pageTitle || appendGOATandCountryCodeToTitle(title, locale),
    pageDescription: pageDescription || description,
  };
};
